var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgInsertAttach = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 20,
    viewBox: "0 0 11 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8C9EA7",
    fillRule: "nonzero",
    d: "M6.934 0C4.743 0 2.96 1.705 2.96 3.802v9.162c0 1.319 1.119 2.391 2.495 2.391 1.375 0 2.494-1.072 2.494-2.39V8.31c0-.276-.227-.5-.507-.5a.504.504 0 0 0-.507.5v4.653c0 .767-.664 1.391-1.482 1.391-.815 0-1.479-.624-1.479-1.39V3.801C3.974 2.257 5.302 1 6.934 1c1.633 0 2.96 1.257 2.96 2.802v10.987C9.896 17.11 7.904 19 5.455 19c-2.448 0-4.44-1.89-4.44-4.211V8.31c0-.276-.227-.5-.507-.5a.503.503 0 0 0-.507.5v6.478C0 17.662 2.447 20 5.454 20c3.008 0 5.455-2.338 5.455-5.211V3.802C10.91 1.705 9.126 0 6.934 0z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgInsertAttach, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/insert-attach.b6e9d5b5.svg";
export { ForwardRef as ReactComponent };